export const baseURL = "https://clupp-api.web.app/v1/clupp/users";
